var path = 'components/documentIndexesEdit/documentIndexesEdit.template.html';
var html = "<section class=\"smb-app__document-indexes--edit smb-app__document-side-panel\"> <header> <h1 translate>Edit Fields</h1> </header> <smb-indexes indextypes=vm.indexes status=vm.fieldsStatus></smb-indexes> <div layout=row layout-align=\"end end\"> <md-button ng-click=vm.documentDetailsDS.toggle(vm.documentDetailsDS.fieldPanel)> <translate>Cancel</translate> </md-button> <md-button class=md-raised ng-disabled=!vm.fieldsStatus.isValid ng-click=vm.saveIndexes()> <translate>Update</translate> </md-button> </div> </section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/documentIndexesEdit/documentIndexesEdit.template.html
// module id = 185
// module chunks = 1